<template>
  <div class="navbar navbar-expand-lg navbar-light bg-light justify-content-between">
    <div class="container">
      <a class="navbar-brand" href="#">
        <img alt="Logo" height="40" src="../assets/logo.png">
      </a>
      <span class="navbar-text">Meine Abmeldungen</span>
    </div>
  </div>
  <div class="container">
    <div class="container mt-3">
      <router-view v-if="this.selfServiceStore.authenticated"></router-view>
      <SelfServiceLogin v-else></SelfServiceLogin>
    </div>
  </div>
</template>

<script>
import {useSelfServiceStore} from "@/stores/selfService";
import SelfServiceLogin from "@/components/SelfServiceLogin.vue";

export default {
  name: 'PublicShell',
  components: {SelfServiceLogin},
  setup() {
    const selfServiceStore = useSelfServiceStore();
    return {selfServiceStore};
  },
  mounted() {
    this.selfServiceStore.getSession();
  },
}
</script>
